var map = {
	"./TSG71-2023_page0.jpg": 6628,
	"./TSG71-2023_page1.jpg": 225,
	"./TSG71-2023_page10.jpg": 2461,
	"./TSG71-2023_page2.jpg": 4438,
	"./TSG71-2023_page3.jpg": 2851,
	"./TSG71-2023_page4.jpg": 2688,
	"./TSG71-2023_page5.jpg": 781,
	"./TSG71-2023_page6.jpg": 6626,
	"./TSG71-2023_page7.jpg": 3007,
	"./TSG71-2023_page8.jpg": 1548,
	"./TSG71-2023_page9.jpg": 9337,
	"./TSG71-2023_pagenone.jpg": 7888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6203;